import React, { ReactElement, useEffect } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import serverConfig from '@/server-config'
import ModelAuctionCardDetails from '@/components/auction/ModalAuctionCardDetails'

axios.defaults.baseURL = serverConfig.baseURL

const DetailsOverview = ({ artData, onClose }: { artData: ArtData; onClose: () => void }): ReactElement => {
    useEffect(() => {
        const nftHash = `nft-${artData.tokenId?.toString()}`
        if (!window.location.hash.includes(nftHash)) {
            window.location.hash = nftHash
        }
    }, [artData])

    return (
        <div>
            {artData?.art && (
                <div>
                    <h1 className="title">Crazy NFT #{artData.tokenId}</h1>
                    <div className="container">
                        <div>
                            <ModelAuctionCardDetails artData={artData} onClose={onClose} />
                            <div className="prompts">
                                {/*<AuctionCardTooltip key={artData.art.id} artData={artData}/>*/}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default DetailsOverview
